import OauthLogin from './OauthLogin';

export default OauthLogin;
